import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getArticles = () => api.get("/articles").then((r) => r.data);
export const getArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
export const getDailyPrompt = () => api.get("/daily-prompt").then((r) => r.data);
export const sendChat = (session_id, message) =>
    api.post("/chat", { session_id, message }).then((r) => r.data);
export const getChatHistory = (session_id) =>
    api.get(`/chat/${session_id}`).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (email) =>
    api.post("/newsletter", { email }).then((r) => r.data);
